import React from 'react'
import { HashRouter } from 'react-router-dom'
import {createBrowserHistory} from 'history'
import {createStore, applyMiddleware} from 'redux'
import {Provider} from 'react-redux'
import thunk from 'redux-thunk'
import {composeWithDevTools} from 'redux-devtools-extension'
import * as Sentry from "@sentry/react"
import {BrowserTracing} from '@sentry/tracing'
import rootReducer from './rootReducer'
import RouteContainer from './routes/RouteContainer'
import SentryRRWeb from "@sentry/rrweb"

const history = createBrowserHistory()

Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [new BrowserTracing(
        {
            routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
        }
    ),
        new SentryRRWeb()
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    environment: process.env.ENVIRONMENT,
    release: process.env.RELEASE
})

export const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunk)))


const App = () => {
    return (
        <div className="App">
            <Provider store={store}>
                <HashRouter basename='/' history={history}>
                    <RouteContainer/>
                </HashRouter>
            </Provider>
        </div>
    )
}

export default App
